import { DropdownMenu } from 'ui';
import { DownloadGreyIcon } from 'ui/icons';
import { ReportFormat } from 'api';

interface TaxReportDownloadDropdownProps {
  disabled?: boolean;
  onDownload: (format: ReportFormat) => void;
}

export const TaxReportDownloadDropdown = ({
  disabled = false,
  onDownload,
}: TaxReportDownloadDropdownProps) => {
  return (
    <DropdownMenu
      items={[
        {
          label: 'PDF',
          onClick: () => onDownload(ReportFormat.Pdf),
        },
        {
          label: 'XLSX',
          onClick: () => onDownload(ReportFormat.Xlsx),
        },
      ]}
      disabled={disabled}
      placement="left-start"
      containerClassName="w-auto"
      className="!w-[110px] !py-1"
      itemClassName="!px-3 !py-2"
      button={
        <button className="flex items-center justify-center">
          <img
            src={DownloadGreyIcon}
            className="hover:opacity-70 cursor-pointer min-w-6 w-6 h-6 min-h-6"
            alt="download"
          />
        </button>
      }
    />
  );
};
